import { Box } from '../Common/Box';
import { PaymentMethodEnum } from '@/types/common';
import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { getPaymentMethodLogoUrl } from '@/utils/paymentMethods';

export const EPSPayBox = () => {
  const {
    paymentMethodSelected,
    actions: { setPaymentMethodSelected },
  } = useContext(CheckoutContext);
  return (
    <Box
      isSelected={paymentMethodSelected === PaymentMethodEnum.EPS}
      onSelect={() => setPaymentMethodSelected(PaymentMethodEnum.EPS)}
    >
      <img src={getPaymentMethodLogoUrl(PaymentMethodEnum.EPS)} alt="eps" />
    </Box>
  );
};
